import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Formulario from "./components/formulario"; // Asegúrate de que la ruta sea correcta
import "./styles/style__default.css"; // Importamos el archivo CSS
import Descarga from "./components/descarga";
import FInicioSesion from "./components/fInicioSesion";
import VCompetencia from "./components/vCompetencia";
import VTerminosYCondiciones from "./components/vTerminos&Condiciones";
import ResetPassword from "./components/resetPassword";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from "./context/AuthContext"; // Asegúrate de que la ruta es correcta
import ProtectedRouteGame from "./context/ProtectetRouteGame"; // Asegúrate de tener la ruta correcta
import ProtectedRouteStaff from "./context/ProtectetRouteStaff"; // Asegúrate de tener la ruta correcta
import { Navigate } from "react-router-dom";

const InstallPWA = () => {
  // Estado para manejar la visibilidad del banner
  const [showBanner, setShowBanner] = useState(false);

  // Función para verificar el tamaño de la ventana
  const checkScreenSize = () => {
    setShowBanner(true);

    // if (window.innerWidth >= 768) {
    //   setShowBanner(true);
    // } else {
    //   setShowBanner(false);
    // }
  };

  // Hook para verificar el tamaño de la pantalla al cargar el componente
  useEffect(() => {
    checkScreenSize(); // Verifica el tamaño de la ventana al cargar la página

    // Listener para el cambio de tamaño de la ventana
    window.addEventListener("resize", checkScreenSize);

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <div className="ContenedorFormulario height__full">
      <a
        id="soporte-tecnico"
        href="mailto:soportejuegayenvideo@gmail.com"
        data-bs-toggle="tooltip"
        title="Contactar con soporte técnico"
      >
        <i class="bi bi-question-circle color__white"></i>
      </a>
      <div className="full-screen-banner">
        <div className="banner-content">
          <p>
            Sitio cerrado temporalmente. Se propondra una nueva fecha para el
            evento.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
